import { type QuizQuestionRemoveInput, type QuizQuestionRemoveSuccess, toResponseError } from '@terros/common'
import { useQuizCache } from '../cache'
import { useTantalimMutation } from '../../mutation'
import { mutationRemove, type RemoveHookResponse } from '../../hooks'

export function useRemoveQuizQuestion(): RemoveHookResponse<QuizQuestionRemoveInput> {
  const mutation = useTantalimMutation<QuizQuestionRemoveInput, QuizQuestionRemoveSuccess>({
    url: '/quiz/question/remove',
  })
  const cache = useQuizCache()

  async function remove(input: QuizQuestionRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input.quizId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
